import { render, staticRenderFns } from "./OverallSituation.vue?vue&type=template&id=1ca8d72d"
import script from "./OverallSituation.vue?vue&type=script&lang=js"
export * from "./OverallSituation.vue?vue&type=script&lang=js"
import style0 from "./OverallSituation.vue?vue&type=style&index=0&id=1ca8d72d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports